import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { PostcodeLightBoxHeader } from './postcode_light_box_header';
import { PostcodeLightBoxContent } from './postcode_light_box_content';

function PostcodeLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['postcode-light-box__lightbox']}
        >
            <div className="postcode-light-box">
                <PostcodeLightBoxHeader />
                <PostcodeLightBoxContent
                    visible={props.visible}
                    showError={props.showError}
                    postcode={props.postcode}
                    postcodeInvalid={props.postcodeInvalid}
                    postcodeInvalidMessage={props.postcodeInvalidMessage}
                    onChange={props.onChange}
                    onSubmit={props.onSubmit}
                    store={props.store}
                    selectPostcodeSuggestion={props.selectPostcodeSuggestion}
                />
            </div>
        </Lightbox>
    );
}

PostcodeLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    postcode: PropTypes.string.isRequired,
    postcodeInvalid: PropTypes.bool.isRequired,
    postcodeInvalidMessage: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { PostcodeLightBox };
